var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar row-block height-full",class:{ active: _vm.active },style:({ height: _vm.minHeight + 'px' }),on:{"mouseenter":function (e) { return _vm.active = true; },"mouseleave":function (e) { return _vm.active = false; }}},[_c('sidebarMain',{attrs:{"active":_vm.active}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52f6adb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/sidebar.vue
// module id = null
// module chunks = 